import type { ComponentType, FC } from 'react';
import dynamic from 'next/dynamic';
const Teaser = dynamic(() => import('@/components/teaser/Teaser'));
const Accordion = dynamic(() => import('@/components/accordion/Accordion'));
const StaticImage = dynamic(() => import('@/components/image/StaticImage'));
const RichText = dynamic(() => import('@/components/RichText/RichText'));
const Tabs = dynamic(() => import('@/components/tabs/Tabs'));
const SimpleHeaderText = dynamic(() => import('@/components/SimpleHeaderText'));
const FixedColumnLayout = dynamic(() => import('@/components/fixedColumnLayout/FixedColumnLayout'));
const LeftNavi = dynamic(() => import('@/components/leftNavi/LeftNavi'));
const FeatureList = dynamic(() => import('@/components/featureList/FeatureList'));
const LinkList = dynamic(() => import('@/components/linkList/LinkList'));
const Link = dynamic(() => import('@/components/linkList/Link'));
const AccordionElementArea = dynamic(() => import('@/components/accordion/AccordionElementArea'));

export interface MagnoliaMappingConfig {
  componentMappings: { [key: string]: FC<any> | ComponentType<any> };
}

export const configForEditablePageContext: MagnoliaMappingConfig = {
  componentMappings: {
    'website:components/richText': RichText,
    'website:components/image': StaticImage,
    'website:components/accordion': Accordion,
    'website:components/accordionElement': AccordionElementArea,
    'website:components/tabs': Tabs,
    'website:components/simpleHeaderText': SimpleHeaderText,
    'website:components/fixedColumnLayout': FixedColumnLayout,
    'website:components/leftNavi': LeftNavi,
    'website:components/featureList': FeatureList,
    'website:components/teaser': Teaser,
    'website:components/link': Link,
    'website:components/linkList': LinkList
  }
};
